module.exports = __webpack_public_path__ + "static/pandora-e07989494b14dfe429691f64b5340a97.png";